import React, { useEffect } from 'react';
import styled from 'styled-components/macro';
import Slider from './Slider';
import Card from './Card';
import { connect } from 'react-redux';
import { fetchFavourites, fetchSideNav } from '../actions';
import translate from './TranslateHOC';
import { CardRowLoading } from '../v2/components/loading/CardRowLoading';
import LoadingError from './alerts/LoadingError';

function CardRow({
  strings,
  items,
  itemsIsLoading,
  itemsHasErrored,
  favourites,
  itemSelectedId,
  signed,
  isLive,
  isExtraFeed,
  isHero,
  cardBtn,
  billingBool,
  countBool,
  itemsLimit,
  gridType,
  sliderClass,
  playPos,
  seriesLevel = false,
  limitInt = parseInt(itemsLimit, 10),
  isSideNavToggled,
}) {
  let slidesToScrollDefault = 9;
  let slidesToShowDefault = 9;
  let responsiveSettings = [
    { breakpoint: 475, settings: { slidesToScroll: 2, slidesToShow: 2 } },
    { breakpoint: 716, settings: { slidesToScroll: 3, slidesToShow: 3 } },
    { breakpoint: 1140, settings: { slidesToScroll: 4, slidesToShow: 4 } },
    { breakpoint: 1829, settings: { slidesToScroll: 5, slidesToShow: 5 } },
    { breakpoint: 2077, settings: { slidesToScroll: 6, slidesToShow: 6 } },
    { breakpoint: 2325, settings: { slidesToScroll: 7, slidesToShow: 7 } },
    { breakpoint: 2573, settings: { slidesToScroll: 8, slidesToShow: 8 } },
  ];

  const limitCards =
    limitInt && limitInt > 0 ? limitInt : Object.keys(items).length;
  const sliderClassName = sliderClass ? sliderClass.toLowerCase() : '';
  const playPosition = playPos === true ? true : false;

  useEffect(() => {
    fetchFavourites();
  }, []);

  if (itemsIsLoading) {
    return <CardRowLoading />;
  }

  if (itemsHasErrored) {
    return (
      <CardRowContainer>
        <LoadingError errorMessage={strings.sorryLoading} />
      </CardRowContainer>
    );
  }

  return (
    <CardRowContainer navClosed={!isSideNavToggled}>
      {Object.keys(items).length > 0 && (
        <Slider
          className={
            sliderClassName + ' card-slick ' + (gridType ? gridType : '')
          }
          slidesToScrollDefault={slidesToScrollDefault}
          slidesToShowDefault={slidesToShowDefault}
          responsiveSettings={responsiveSettings}
          strings={strings}
        >
          {Object.keys(items)
            .slice(0, limitCards)
            .map((key) => (
              <CardContainer key={key}>
                <Card
                  key={key}
                  index={key}
                  details={items[key]}
                  isFav={
                    favourites && favourites.length > 0
                      ? favourites.includes(key)
                      : false
                  }
                  billingBool={billingBool}
                  countBool={countBool}
                  playPos={playPosition}
                  signed={signed}
                  isLive={isLive}
                  isExtraFeed={isExtraFeed}
                  isHero={isHero}
                  isSlick={true}
                  cardBtn={cardBtn}
                  active={
                    itemSelectedId &&
                    itemSelectedId !== 'undefined' &&
                    itemSelectedId === items[key].id
                      ? true
                      : false
                  }
                  seriesLevel={seriesLevel}
                />
              </CardContainer>
            ))}
        </Slider>
      )}
    </CardRowContainer>
  );
}

const CardRowContainer = styled.div`
  max-width: 1240px;
  @media screen and (min-width: 1830px) {
    max-width: 1488px;
  }
  @media screen and (min-width: 2078px) {
    max-width: 1736px;
  }
  @media screen and (min-width: 2326px) {
    max-width: 1984px;
  }
  @media screen and (min-width: 2574px) {
    max-width: 2232px;
  }
  ${(props) =>
    props.navClosed &&
    `
    max-width: 1488px;
    @media screen and (min-width: 1830px) {
      max-width: 1736px;
    }
    @media screen and (min-width: 2078px) {
      max-width: 1984px;
    }
    @media screen and (min-width: 2326px) {
      max-width: 2232px;
    }
    @media screen and (min-width: 2574px) {
      max-width: 2480px;
    }
  `};
`;

const CardContainer = styled.div`
  @media screen and (min-width: 768px) {
    margin-right: 15px;
  }
`;

function mapStateToProps(state) {
  return {
    favourites: state.favourites,
    isSideNavToggled: state.sideNav,
    curLang: state.curLang,
  };
}

export default translate(
  connect(mapStateToProps, { fetchFavourites, fetchSideNav })(CardRow)
);
